module.exports = __webpack_public_path__ + "img/tablet.ae9e3cd0.jpg";